import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Row, Col, DatePicker, Switch, Button, Form} from 'antd'
import moment from 'moment'
import CronGenerator from './CronGenerator'
import '../../../assets/api.css'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'

const noEndDate = '2099-12-31 23:59:59'

@inject('apiManagementStore')
@observer
class FormModal extends Component {
  state = {
    addModalVisible: this.props.addModalVisible,
    endStatus: false,
    enable: false,
    cronText: '* * * * * *',
    cronType: ['second', 'minute', 'hour', 'day', 'month', 'week'],
    radioValue: {
      second: 1,
      minute: 1,
      hour: 1,
      day: 1,
      month: 1,
      week: 1,
    },
    periodValue: {
      second: {max: 1, min: 1},
      minute: {max: 1, min: 1},
      hour: {max: 1, min: 1},
      day: {max: 1, min: 1},
      month: {max: 1, min: 1},
      week: {max: 1, min: 1},
    },
    loopValue: {
      second: {start: 1, end: 1},
      minute: {start: 1, end: 1},
      hour: {start: 1, end: 1},
      day: {start: 1, end: 1},
      month: {start: 1, end: 1},
      week: {start: 1, end: 1},
    },
    cron: {
      second: '*',
      minute: '*',
      hour: '*',
      day: '*',
      month: '*',
      week: '*',
    },
    cronParams: {
      second: '*',
      minute: '*',
      hour: '*',
      day: '*',
      month: '*',
      week: '*',
    }
  }

  formRef = React.createRef()

  changeTabPosition = e => {
    this.setState({tabPosition: e.target.value})
  }

  componentDidMount() {
    const {apiManagementStore} = this.props
    const {scheduledConfigInfo} = apiManagementStore
    if (scheduledConfigInfo) {
      const {endTime, period, enable} = scheduledConfigInfo
      this.setState({
        endStatus: endTime ? moment(endTime).format('YYYY-MM-DD HH:mm:ss') !== noEndDate : true,
        enable: enable
      })
      this.reverseGenerateCRON(period || '* * *      ')
    }
  }

  /**
   * @name: 反编译解析表达式
   * @param {*} express 表达式对象
   * @return {*}
   */
  reverseGenerateCRON = (express) => {
    let cronArr = express.split(' ')
    let newCron = JSON.parse(JSON.stringify(this.state.cron))
    newCron.second = cronArr[0] ?? newCron.second
    newCron.minute = cronArr[1] ?? newCron.minute
    newCron.hour = cronArr[2] ?? newCron.hour
    newCron.day = cronArr[3] ?? newCron.day
    newCron.month = cronArr[4] ?? newCron.month
    newCron.week = cronArr[5] ?? newCron.week
    // newExpress.year = cronArr[6] ?? newExpress.year

    let newRadioValue = JSON.parse(JSON.stringify(this.state.radioValue))
    newRadioValue.second = this.getType(newCron.second, 'second')
    newRadioValue.minute = this.getType(newCron.minute, 'minute')
    newRadioValue.hour = this.getType(newCron.hour, 'hour')
    newRadioValue.day = this.getType(newCron.day, 'day')
    newRadioValue.month = this.getType(newCron.month, 'month')
    newRadioValue.week = this.getType(newCron.week, 'week')
    // newRadioValue.year = this.getType(express.year, 'year')
    this.setState({radioValue: newRadioValue, cron: newCron, cronText: express})
  }

  /**
   * @name: 反解析cron表达式到UI时，每个阈内容进行解析 - 获取每个阈使用的类型和具体值
   * @param {*} expStr cron表达式内容，例如：*，5L
   * @param {*} expressType cron阈类型，例如：minute，hour，week
   * @return {*} 每个阈使用的类型
   */
  getType = (expStr, expressType) => {
    if (expStr === '*') return 1
    else if (expStr === '?') return 2
    // else if (expStr === 'L') return 'lastDay'
    else if (new RegExp('[-]').test(expStr)) {
      let newPeriodValue = this.state.periodValue
      let values = expStr.split('-')
      newPeriodValue[expressType] = {min: parseInt(values[0]), max: parseInt(values[1])}

      this.setState({periodValue: newPeriodValue})
      return 'period'
    } else if (new RegExp('[/]').test(expStr)) {
      let newLoopValue = this.state.loopValue
      let values = expStr.split('/')
      newLoopValue[expressType] = {startTime: parseInt(values[0]), period: parseInt(values[1])}

      this.setState({loopValue: newLoopValue})
      return 'loop'
    } else if (new RegExp('[,]|^\\d{0,2}').test(expStr)) {
      let newCronParams = this.state.cronParams
      let values = expStr.split(',')
      if (expressType === 'week') {
        for (let i = 0; i < values.length; i++) {
          values[i] = values[i]
        }
      } else {
        for (let i = 0; i < values.length; i++) {
          values[i] = parseInt(values[i])
        }
      }

      newCronParams[expressType] = values

      this.setState({cronParams: newCronParams})
      return 'point'
    }
      // else if (new RegExp('[W]').test(expStr)) {
      // 	let value = parseInt(expStr.substring(0, 1))
      // 	this.setState({ mostRecentWorkDay: value })
      // 	return 'mostRecentWorkDay'
      // }
      // else if (new RegExp('[L]').test(expStr)) {
      // 	this.setState({ lastWeekDay: parseInt(expStr.substring(0, 1)) })
      // 	return 'lastWeekDay'
      // }
      // else if (new RegExp('[#]').test(expStr)) {
      // 	let newWeekday = this.state.weekday
      // 	let values = expStr.split('#')
      // 	newWeekday = { weekNum: parseInt(values[0]), weekDayNum: parseInt(values[1]) }
      // 	this.setState({ weekday: newWeekday })
      // 	return 'weekday'
      // }
      // else if (expStr === '') {
      // 	return 'optional'
    // }
    else return
  }

  onChangeSwitch = (checked, e) => {
    this.setState({
      endStatus: checked === true ? false : true
    })
    const {endStatus} = this.state
    this.setState({endStatus: !endStatus})
  }

  handleOk = () => {
    const {apiManagementStore, record, handleCancel} = this.props
    const {endStatus} = this.state
    this.formRef.current.validateFields().then(fieldsValue => {
      if (!fieldsValue.startTime) {
        alertMessage.alert('Please select start time！')
        return
      } else if (endStatus && !fieldsValue.endTime) {
        alertMessage.alert('Please select end time！')
        return
      } else if (endStatus && new Date(fieldsValue.startTime) > new Date(fieldsValue.endTime)) {
        alertMessage.alert('The end time cannot be less than the start time！')
      } else {
        this.createCron().then(res => {
          if (this.state.cronText === '     ') {
            alertMessage.alert('Please set the correct recurrence pattern!')
            return
          }
          let {day, week} = this.state.cron
          if (day !== '?' && week !== '?') {
            alertMessage.alert('Date and week cannot be specified together!')
            return
          }
          apiManagementStore.onScheduleApiAction(record.id, {
            startTime: moment(fieldsValue.startTime).format('YYYY-MM-DD HH:mm:ss'),
            endTime: endStatus ? moment(fieldsValue.endTime).format('YYYY-MM-DD HH:mm:ss') : noEndDate,
            periodCorn: this.state.cronText
          }, this.state.enable)
          handleCancel()
        })
      }
    }).catch(err => {})
  }

  //生成cron
  createCron = async () => {
    let {cronType} = this.state
    for (let type of cronType) {
      await this.cronGenerator(type)
    }
    let {second, minute, hour, day, month, week} = this.state.cron
    let cronText = second + ' ' + minute + ' ' + hour + ' ' + day + ' ' + month + ' ' + week
    this.setState({
      cronText: cronText
    })
  }

  /**
   * cron生成器
   * @param type
   */
  cronGenerator = (type) => {
    let srv = this.state.radioValue[type]
    let period = this.state.periodValue[type]
    let loop = this.state.loopValue[type]
    let param = this.state.cronParams[type]
    let data = ''
    switch (srv) {
      case 1:
        data = '*'
        break
      case 2:
        data = '?'
        break
      case 'point':
        for (let v of param) {
          data = data + v + ','
        }
        data = data.substring(0, data.length - 1)
        break
      case 'period':
        data = period.min + '-' + period.max
        break
      case 'loop':
        data = loop.start + '/' + loop.end
        break
      default:
        data = ''
    }
    this.setState({
      cron: Object.assign({}, this.state.cron, this.cronItemGenerator(type, data))
    })
  }

  /**
   * 对象生成器
   * @param type
   * @param data
   * @returns {{second: *}|{minute: *}}
   */
  cronItemGenerator = (type, data) => {
    switch (type) {
      case 'second':
        return {second: data}
      case 'minute':
        return {minute: data}
      case 'hour':
        return {hour: data}
      case 'day':
        return {day: data}
      case 'month':
        return {month: data}
      case 'week':
        return {week: data}
    }
  }

  /**
   * 格式化0~9的数字
   * @param num
   */
  formatNum = (num) => {
    if (num < 10 && num > -1) {
      return '0' + num
    }
    return num
  }

  handleRadioChange = (e, type) => {
    const {radioValue, cronParams} = this.state
    this.setState({
      radioValue: Object.assign({}, radioValue, this.cronItemGenerator(type, e.target.value)),
      cronParams: Object.assign({}, cronParams, this.cronItemGenerator(type, e.target.value === 'point' ? [0] : []))
    })
  }

  handleCheckboxChange = (checkedValues, type) => {
    const {radioValue, cronParams} = this.state
    this.setState({
      radioValue: Object.assign({}, radioValue, this.cronItemGenerator(type, 'point')),
      cronParams: Object.assign({}, cronParams, this.cronItemGenerator(type, checkedValues))
    })
  }

  handlePeriodChange = (e, type, tar) => {
    let data = this.state.periodValue
    data[type] = tar === 'max' ? {max: e, min: data[type].min} : {max: data[type].max, min: e}
    this.setState({
      periodValue: Object.assign({}, this.state.periodValue, this.cronItemGenerator(type, data[type]))
    })
  }

  handleLoopChange = (e, type, tar) => {
    let data = this.state.loopValue
    data[type] = tar === 'start' ? {start: e, end: data[type].end} : {start: data[type].start, end: e}
    this.setState({
      loopValue: Object.assign({}, this.state.loopValue, this.cronItemGenerator(type, data[type]))
    })
  }
  onChangeEnable = (value) => {
    this.setState({
      enable: value
    })
  }

  render() {
    const {addModalVisible, handleCancel, apiManagementStore, t} = this.props
    const {scheduledConfigInfo} = apiManagementStore
    const {endStatus, enable, cronText, radioValue, periodValue, loopValue, cronParams} = this.state
    return (
      <>
        <Modal
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width="60%"
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <div style={{fontSize: 16, fontWeight: 500, color: '#181818', height: 50, lineHeight: '50px'}}>{t(`apiManagement.recurrencePattern`)}</div>
          <CronGenerator
            createCron={this.createCron}
            handleRadioChange={this.handleRadioChange}
            handleCheckboxChange={this.handleCheckboxChange}
            handlePeriodChange={this.handlePeriodChange}
            handleLoopChange={this.handleLoopChange}
            cronText={cronText}
            radioValue={radioValue}
            periodValue={periodValue}
            loopValue={loopValue}
            cronParams={cronParams}
          />
          <div style={{
            fontSize: 16,
            fontWeight: 500,
            color: '#181818',
            height: 50,
            lineHeight: '50px',
            borderTop: '#dee2e5 1px solid'
          }}>{t(`apiManagement.recurrenceRange`)}
          </div>
          <Form ref={this.formRef} className="searchForm" layout="vertical">
            <Row>
              <Col span={8}>
                <Form.Item name="startTime" label={t(`apiManagement.start`)}
                           initialValue={scheduledConfigInfo.startTime ? moment(scheduledConfigInfo.startTime, 'YYYY-MM-DD HH:mm:ss') : null}>
                  <DatePicker
                    showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                    format={'YYYY-MM-DD HH:mm:ss'}
                    placeholder={`${t(`general.pleaseEnter`)} ${t(`apiManagement.start`)}`}
                    style={{width: '200px'}}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="endTime" label={t(`apiManagement.end`)}
                           initialValue={scheduledConfigInfo.endTime ? moment(scheduledConfigInfo.endTime, 'YYYY-MM-DD HH:mm:ss') : null}>
                  <DatePicker
                    showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                    disabled={!endStatus}
                    format={'YYYY-MM-DD HH:mm:ss'}
                    placeholder={`${t(`general.pleaseEnter`)} ${t(`apiManagement.end`)}`}
                    style={{width: '200px'}}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{marginTop: 4}}>
                <Switch
                  checked={endStatus}
                  checkedChildren={t(`apiManagement.haveEndDate`)}
                  unCheckedChildren={t(`apiManagement.noEndDate`)}
                  onChange={this.onChangeSwitch}
                />
              </Col>
              <Col span={24} style={{marginTop: 20}}>
                <Switch
                  checked={enable}
                  checkedChildren={t(`general.enable`)}
                  unCheckedChildren={t(`general.disable`)}
                  onChange={this.onChangeEnable}
                />
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
